export function getCookie(name) {
  if (typeof document === 'undefined') return '';
  return document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)')?.pop() || '';
}
